import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Vote, X, ArrowRight } from "lucide-react";

export const EarlyVotingBanner = () => {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("evBannerDismissed") === "1");
  const now = new Date();
  const evStart = new Date("2026-07-17T00:00:00-05:00");
  const evEnd = new Date("2026-08-02T00:00:00-05:00");
  const electionEnd = new Date("2026-08-07T00:00:00-05:00");
  if (hidden || now >= electionEnd) return null;

  let msg;
  if (now < evStart) msg = <>🗳️ <strong>Early Voting starts July 17</strong> — runs through Aug 1 · Election Day Aug 6</>;
  else if (now < evEnd) msg = <>🗳️ <strong>Early Voting is OPEN</strong> — July 17 &ndash; Aug 1 · Election Day Aug 6</>;
  else msg = <>🗳️ <strong>Election Day is Thursday, August 6</strong> — make your plan to vote</>;

  const dismiss = () => {
    sessionStorage.setItem("evBannerDismissed", "1");
    setHidden(true);
  };

  return (
    <div className="bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-slate-950" data-testid="early-voting-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-center gap-3 text-xs sm:text-sm">
        <span className="leading-tight">{msg}</span>
        <Link
          to="/tn-ballots"
          data-testid="ev-banner-ballot-link"
          className="inline-flex items-center gap-1 bg-slate-950 text-amber-300 font-bold px-3 py-1 rounded-full hover:bg-slate-800 transition-colors flex-shrink-0"
        >
          <Vote className="w-3 h-3" /> Find Your Ballot <ArrowRight className="w-3 h-3" />
        </Link>
        <button onClick={dismiss} aria-label="Dismiss" data-testid="ev-banner-dismiss" className="p-1 hover:bg-amber-600/40 rounded-full flex-shrink-0">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
